import { gql } from '@apollo/client';

import { academyProfessorFragment } from '../fragments';
import { AcademyProfessor } from '../../types';

export interface ToggleProfessorMutationVariables {
  professorId: string;
  action: 'disable' | 'enable';
}

export interface ToggleProfessorMutationResult {
  academyProfessor: AcademyProfessor;
}

export const toggleProfessorMutation = gql`
  mutation ToggleProfessorMutation($professorId: String!, $action: String!) {
    academyProfessor(professorId: $professorId, action: $action, input: {})
      @rest(type: "AcademyProfessor", path: "academy/professors/{args.professorId}/{args.action}", method: "PUT") {
      ...AcademyProfessor
    }
  }
  ${academyProfessorFragment}
`;
